import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Stepper, Step } from '@cfa/react-components';
import { getActiveStep, getHash } from '../../util/location';
import { useMemo } from 'react';

const ProgressStepper = ({ steps, history, stepCompleted }) => {
  const handleOnClick = (step) => {
    if (!step.disabled && step.completed) {
      const { path, value } = step;
      stepCompleted(value);
      history.push(`${path}#id_token=${getHash().id_token}`);
    }
  };

  const active = useMemo(() => {
    return getActiveStep();
  }, [window.location.pathname]);

  if (active != null) {
    return (
      <StyledProgressStepper>
        <Stepper activeStep={active} style={{ padding: '3em' }}>
          {steps.map((step) => (
            <Step
              key={step.value}
              index={step.value}
              label={step.title}
              disabled={!step.completed || step.disabled}
              onClick={() => handleOnClick(step)}
            />
          ))}
        </Stepper>
      </StyledProgressStepper>
    );
  }

  return null;
};

const StyledProgressStepper = styled.div`
  & .cfa-step-icon-container {
    cursor: default;
    &[aria-disabled='false']:hover {
      cursor: pointer;
    }
  }
`;

ProgressStepper.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  stepCompleted: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ProgressStepper;
